module.exports = __webpack_public_path__ + "media/assets/stores/google-play-0ee2e87462825bfa98c02c27b1d4ee83.png";